import React__default from"react";
/**
 * A utility type for creating polymorphic components.
 *
 * Allows a component to accept the props of another component or element,
 * omitting those which conflict with the polymorphic component.
 */
/**
 * This Typescript utility transform a list of slots into a list of {slot: classes}
 * @example
 * ```ts
 * const styles = pdsTv({
 *   slots: {
 *    base: "...",
 *    card: "...",
 *   },
 * });

 * export type YourTypeSlots = keyof ReturnType<typeof styles>;
 * type YourType = SlotsToClasses<YourTypeSlots>; // should be { base?: string, card?: string }
 *
 * Inside your component:
 * { classNames: SlotsToClasses<YourTypeSlots> }
 * ```
 */function useDOMRef(ref){var domRef=React__default.useRef(null);return React__default.useImperativeHandle(ref,function(){return domRef.current}),domRef}
/**
 * Restricts (clamps) a numeric value to lie within the inclusive range
 * defined by the provided minimum and maximum bounds.
 *
 * The returned value will be:
 * - `min` if `value` is less than `min`
 * - `max` if `value` is greater than `max`
 * - otherwise the original `value`
 *
 * @param value - The numeric value to clamp.
 * @param min - The inclusive lower bound.
 * @param max - The inclusive upper bound.
 * @returns The clamped numeric value constrained to the range `[min, max]`.
 *
 * @throws Will throw an error if `min` is greater than `max`.
 *
 * @example
 * // Basic usage
 * clamp(10, 0, 100); // 10
 */function clamp(value,min,max){if(min>max)throw new Error("Invalid range: min must be less than or equal to max");return Math.min(Math.max(value,min),max)}export{clamp,useDOMRef};
//# sourceMappingURL=utils.js.map
